import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import {thunk} from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';
import { expenseDetailsReducer, expenseListReducer } from './reducers/expenseReducer';
import { relationshipListReducer, relationshipDetailsReducer, createRelationshipReducer } from './reducers/relationshipReducers'; // Import relationship reducers
import { salesPaymentListReducer, salesPaymentCreateReducer } from './reducers/salesPaymentReducers';

import {
  fileListReducer,
  fileDetailsReducer,
  fileCreateReducer,
  fileUpdateReducer,
  fileDeleteReducer,
} from './reducers/fileReducers'; // Adjust the path as necessary
import {
  userLoadedReducer,
  userRegisterReducer,
  userLoginReducer,
  userLogoutReducer,
  authErrorReducer,
} from './reducers/authReducers';
import {
  taskListReducer,
  taskCreateReducer,
  taskDetailsReducer,
  taskUpdateReducer,
  taskDeleteReducer,
} from './reducers/taskReducers';
import { userReducer } from './reducers/userReducer';

import { setAlertReducer, removeAlertReducer } from './reducers/alertReducers'; 
import {
  timesheetCreateReducer,
  timesheetListReducer,
  timesheetDetailsReducer,
  timesheetUpdateReducer,
  timesheetDeleteReducer,
} from './reducers/timesheetReducers'; // Import timesheet reducers
import {
  salesDocumentCreateReducer,
  salesDocumentListReducer,
  salesDocumentDetailsReducer,
  salesDocumentUpdateReducer,
  salesDocumentDeleteReducer,
} from './reducers/salesDocumentReducers'; // Import sales document reducers

import * as documentReducers from './reducers/documentReducers';
import {
  folderCreateReducer,
  folderListReducer,
  folderByOwnerReducer,
  folderUpdateReducer,
  folderDeleteReducer,
  folderInitializeReducer,
  folderReorderReducer,
} from './reducers/folderReducers';
import {
  appointmentCreateReducer,
  appointmentListReducer,
  appointmentsByCaseReducer,
  appointmentDetailsReducer,
  appointmentUpdateReducer,
  appointmentDeleteReducer,
} from './reducers/appointmentReducers';
import caseReducer from './slices/caseSlice';
import languageReducer from './slices/languageSlice';
import notificationReducer from './reducers/notificationReducer';
// import {
//   disbursementListReducer,
//   disbursementCreateReducer,
// } from "./reducers/disbursementReducers"; // Import disbursement reducers

import {
  disbursementListReducer,
  disbursementCreateReducer,
  disbursementDetailsReducer,
  disbursementUpdateReducer,
  disbursementDeleteReducer,
} from './reducers/disbursementReducer'; // Import disbursement reducers

// ... other existing imports

const reducer = combineReducers({
  notifications: notificationReducer,
  case: caseReducer,
  language: languageReducer,
  appointmentCreate: appointmentCreateReducer,
  appointmentList: appointmentListReducer,
  appointmentsByCase: appointmentsByCaseReducer,
  appointmentDetails: appointmentDetailsReducer,
  appointmentUpdate: appointmentUpdateReducer,
  appointmentDelete: appointmentDeleteReducer,
  documentUpload: documentReducers.documentUploadReducer,
  documentList: documentReducers.documentListReducer,
  documentDownload: documentReducers.documentDownloadReducer,
  documentUpdate: documentReducers.documentUpdateReducer,
  folderCreate: folderCreateReducer,
  folderList: folderListReducer,
  folderByOwner: folderByOwnerReducer,
  folderUpdate: folderUpdateReducer,
  folderDelete: folderDeleteReducer,
  folderInitialize: folderInitializeReducer,
  folderReorder: folderReorderReducer,
  userList: userReducer,
  salesPaymentList: salesPaymentListReducer,
  salesPaymentCreate: salesPaymentCreateReducer,
  userLoaded: userLoadedReducer,
  userRegister: userRegisterReducer,
  userLogin: userLoginReducer,
  userLogout: userLogoutReducer,
  authError: authErrorReducer,
  setAlert: setAlertReducer,
  removeAlert: removeAlertReducer,
  expenseList: expenseListReducer,
  expenseDetails: expenseDetailsReducer,
  taskList: taskListReducer,
  taskCreate: taskCreateReducer,
  taskDetails: taskDetailsReducer,
  taskUpdate: taskUpdateReducer,
  taskDelete: taskDeleteReducer,
  fileList: fileListReducer,
  fileDetails: fileDetailsReducer,
  fileCreate: fileCreateReducer,
  fileUpdate: fileUpdateReducer,
  fileDelete: fileDeleteReducer,
  relationshipCreate: createRelationshipReducer,
  relationshipList: relationshipListReducer,      // Add relationship list reducer
  relationshipDetails: relationshipDetailsReducer, // Add relationship details reducer
  timesheetCreate: timesheetCreateReducer,        // Add timesheet create reducer
  timesheetList: timesheetListReducer,            // Add timesheet list reducer
  timesheetDetails: timesheetDetailsReducer,      // Add timesheet details reducer
  timesheetUpdate: timesheetUpdateReducer,        // Add timesheet update reducer
  timesheetDelete: timesheetDeleteReducer,        // Add timesheet delete reducer
  salesDocumentCreate: salesDocumentCreateReducer, // Add sales document create reducer
  salesDocumentList: salesDocumentListReducer,     // Add sales document list reducer
  salesDocumentDetails: salesDocumentDetailsReducer, // Add sales document details reducer
  salesDocumentUpdate: salesDocumentUpdateReducer, // Add sales document update reducer
  salesDocumentDelete: salesDocumentDeleteReducer, // Add sales document delete reducer
  disbursementList: disbursementListReducer,
  disbursementCreate: disbursementCreateReducer,
  disbursementDetails: disbursementDetailsReducer,
  disbursementUpdate: disbursementUpdateReducer,
  disbursementDelete: disbursementDeleteReducer,

});

// Enable Redux DevTools only in development
const composeEnhancers = process.env.NODE_ENV === 'development' 
  ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) 
  : compose;

const middleware = [thunk];

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;